<template>
  <Header />
  <div :class="$style.container">
    <div :class="$style.content">
      <Filters />
      <Headers />
      <Leads />
      <Pagination />
    </div>
  </div>
  <SoundAlertModal v-if="$store.state.notifications.isLoad" />
</template>

<script>
import Header from "@/components/layouts/Header.vue";
import Filters from "@/components/leads/Filters.vue";
import Headers from "@/components/leads/Headers.vue";
import Leads from "@/components/leads/Leads.vue";
import Pagination from "@/components/leads/Pagination.vue";
import SoundAlertModal from "@/components/modals/SoundAlertModal.vue";
export default {
  components: {
    Header,
    Filters,
    Headers,
    Leads,
    Pagination,
    SoundAlertModal,
  },
  async mounted() {
    await this.$store.dispatch("getLeads", {});
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 1.5rem;
  .content {
    background-color: $bg-secondary;
    border-radius: 1rem;
  }
}
</style>
